import React from 'react';
import { useTranslation } from 'react-i18next';
// Import setting control components once they are created
import LanguageSelector from './components/language-selector';
import FontSizeSelector from './components/font-size-selector';
import FontFamilySelector from './components/font-family-selector';
import ContrastModeSelector from './components/contrast-mode-selector';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'; // Assuming shadcn/ui card is available

const SettingsPage: React.FC = () => {
  const { t } = useTranslation(); // Assuming i18n is configured

  return (
    <div className="container mx-auto p-4 md:p-8">
      <h1 className="mb-6 text-2xl font-semibold md:text-3xl">
        {t('settings.title', 'Settings')}
      </h1>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
        {/* Language Card */}
        <Card>
          <CardHeader>
            <CardTitle>{t('settings.language.title', 'Language')}</CardTitle>
            <CardDescription>
              {t(
                'settings.language.description',
                'Choose your preferred language for the application interface.'
              )}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <LanguageSelector />
          </CardContent>
        </Card>

        {/* Font Size Card */}
        <Card>
          <CardHeader>
            <CardTitle>{t('settings.fontSize.title', 'Font Size')}</CardTitle>
            <CardDescription>
              {t(
                'settings.fontSize.description',
                'Adjust the text size for better readability.'
              )}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <FontSizeSelector />
          </CardContent>
        </Card>

        {/* Font Family Card */}
        <Card>
          <CardHeader>
            <CardTitle>
              {t('settings.fontFamily.title', 'Font Family')}
            </CardTitle>
            <CardDescription>
              {t(
                'settings.fontFamily.description',
                'Select a font that is comfortable for you to read.'
              )}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <FontFamilySelector />
          </CardContent>
        </Card>

        {/* Contrast Mode Card */}
        <Card>
          <CardHeader>
            <CardTitle>
              {t('settings.contrastMode.title', 'Contrast Mode')}
            </CardTitle>
            <CardDescription>
              {t(
                'settings.contrastMode.description',
                'Change the color contrast to improve visibility.'
              )}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ContrastModeSelector />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SettingsPage;
